module.exports = __webpack_public_path__ + "img/industry-windows.4309418d.svg";